export default __webpack_public_path__ + "static/media/rotate.d09526c2.svg";